import React from "react";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { REP_DIRECTORY, getRepDisplayName } from "@/config/constants";

export const isRepUser = (user) => user?.role === "rep";
export const repOf = (user) => user?.assigned_rep_name || user?.name || "";

/**
 * Reps always log against themselves — the field shows their own name and cannot be changed.
 * Managers and admins keep the full rep dropdown.
 */
export const RepField = ({ user, value, onChange, testId, hasError = false, className = "" }) => {
  if (isRepUser(user)) {
    const name = repOf(user);
    return (
      <>
        <Input
          value={getRepDisplayName(name) || name}
          readOnly
          disabled
          className={`bg-muted cursor-not-allowed ${className}`}
          data-testid={testId}
        />
        <p className="text-[11px] text-muted-foreground mt-1 flex items-center gap-1">
          <Lock className="w-3 h-3" />
          Always logged against you
        </p>
      </>
    );
  }

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={`${hasError ? "border-red-500" : ""} ${className}`} data-testid={testId}>
        <SelectValue placeholder="Select rep" />
      </SelectTrigger>
      <SelectContent>
        {REP_DIRECTORY.map((name) => (
          <SelectItem key={name} value={name}>
            {getRepDisplayName(name) || name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default RepField;
